import React, { useEffect, useState } from "react";
import {
  TableCell,
  TableRow,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import SelectMenuItem from "../Customer/Component/SelectMenuItem";
import { useUpdateCustomerMutation } from "../../../Service/customers";
import { useDispatch, useSelector } from "react-redux";
import { GetcustomerList } from "../../../store/async-actions/digitalmarketing/dashboard";
import { useGetDashboardCustomersQuery } from "../../../Service/dashboard";
import { ServiceChosen } from "../Customer/Utils/CustomerLabelInput";
import edit from "../../../assets/DigitalMarketing/image/edit.svg";
import eye from "../../../assets/DigitalMarketing/image/eye.svg";
import facebook from "../../../assets/DigitalMarketing/image/source/Fb.png";
import whatsapp from "../../../assets/DigitalMarketing/image/source/Whatsapp.png";
import x from "../../../assets/DigitalMarketing/image/source/x.png";
import insta from "../../../assets/DigitalMarketing/image/source/insta.png";
import yt from "../../../assets/DigitalMarketing/image/source/YT.png";
import linkedin from "../../../assets/DigitalMarketing/image/source/linkedin.png";
import google from "../../../assets/DigitalMarketing/image/source/g.png";
import walkin from "../../../assets/DigitalMarketing/image/source/walk-in.png";

import PermissionCheck from "../../../Component/PermissionCheck";
const useStyles = makeStyles({
  Mimo: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#FB6A6A",
      backgroundColor: "#FFF7F7",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Fertility: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3BB54A",
      backgroundColor: "#F7FFF8",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Action: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E6E6E6",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  status: {
    width: 148,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
});
interface props {
  customer_list: any;
  getComparator: any;
  order: any;
  orderBy: string;
  handleClick: any;
  handleChange: any;
  handleClickView: any;
  stableSort: any;
}
function TableList({
  customer_list,
  getComparator,
  order,
  orderBy,
  handleClick,
  handleClickView,
  handleChange,
  stableSort,
}: props) {
  const classes = useStyles();
  const [ishover, sethover] = useState(null);
  const handleMouseEnter = (index) => {
    sethover(index);
  };
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account;
  const dispatch = useDispatch<any>();

  const DashboardStatus = useSelector((state: any) => state.dashboard.status);
  const [updateCustomer] = useUpdateCustomerMutation();
  let status = DashboardStatus.map((item) => ({
    label: item.name,
    value: item.id,
    icon: (
      <span
        style={{ backgroundColor: item.others }}
        className="blue me-2"
      ></span>
    ),
  }));

  const handleMouseLeave = () => {
    sethover(null);
  };

  const getValueByLabel = (label) => {
    let val = status.find((item) => item.label == label);
    if (val) {
      return val.value;
    }
    return 1;
  };
  const getLabelByValue = (value) => {
    let val = status.find((item) => item.value == value);
    if (val) {
      return val.label;
    }
    return "Created";
  };

  const handleSelectChange = (event, CustomerDetail) => {
    const { name, value } = event.target;
    if (CustomerDetail.customerId) {
      updateCustomer({
        id: CustomerDetail.customerId,
        customerStatus: getLabelByValue(value),
      });
      dispatch(GetcustomerList());
      // useGetDashboardCustomersQuery()
    }
  };

  const handleServiceChosenChange = (event, CustomerDetail) => {
    const { name, value } = event.target;
    if (CustomerDetail.customerId) {
      updateCustomer({
        id: CustomerDetail.customerId,
        serviceChoosen: value,
      });
      dispatch(GetcustomerList());
      // useGetDashboardCustomersQuery()
    }
  };
  function getImageSource(sourceValue) {
    if (sourceValue) {
      const lowerCaseValue = sourceValue.toLowerCase();

      switch (lowerCaseValue) {
        case "facebook":
          return facebook;
        case "whatsapp":
          return whatsapp;
        case "youtube":
          return yt;
        case "linkedin":
          return linkedin;
        case "instagram":
          return insta;
        case "google":
          return google;
        case "walk-in":
          return walkin;
        case "twitter":
          return x;
      }
    } else {
      return;
    }
  }

  return (
    <>
      {stableSort(customer_list, getComparator(order, orderBy))?.map((a, i) => {
        return (
          <TableRow role="checkbox" tabIndex={-1} key={i}>
            <TableCell align="left">{a.created}</TableCell>
            <TableCell align="left">{a.name}</TableCell>
            <TableCell align="left">{a.phone_number}</TableCell>
            <TableCell align="left">{a.branchName}</TableCell>
            <TableCell className="center" align="left">
              <p>{a?.categoryDetails?.categoryName}</p>
            </TableCell>
            <TableCell align="left">
              {a.leadType === "fertility" && (
                <div>
                  <span
                    className="p-2 rounded"
                    style={{ backgroundColor: "#E5EFBA" }}
                  >
                    Fertility
                  </span>
                </div>
              )}
              {a.leadType === "general" && (
                <div>
                  <span
                    className="p-2 rounded"
                    style={{ backgroundColor: "#FFE1D0" }}
                  >
                    General
                  </span>
                </div>
              )}
            </TableCell>
            {/* {account.permissions.ivf_journey_status !== 1 && ( */}
            {/* <TableCell align="left">
                <FormControl sx={{ m: 0, minWidth: 120 }}>
                  {(a.stagesName || a.stepsName) && (
                    <div className="ivf-service-box">
                      <span className="mb-0">{a.stagesName}</span>
                      <br />
                      <span className="mb-0">{a.stepsName}</span>
                    </div>
                  )}
                </FormControl>
              </TableCell> */}
            {/* )} */}
            <TableCell align="left">
              {a.source && (
                <>
                  <div className="d-flex">
                    <img
                      src={getImageSource(a.source)}
                      style={{ width: "18px", height: "18px" }}
                      className="blue-c me-1"
                      alt="source"
                    />{" "}
                    {a.source}
                  </div>
                </>
              )}
            </TableCell>

            <TableCell align="left">
              <FormControl sx={{ m: 1, minWidth: 120 }}>
                {/* <SelectMenuItem 
                styles={"select"} 
                name="stat" 
                option={status} 
          
                value={getValueByLabel(a.customerStatus)} 
                onChange={(e) => handleSelectChange(e,a)} 
                /> */}
                {status.map(
                  (item) =>
                    item.label === a.customerStatus && (
                      <span key={item.label}>
                        {item.icon}&nbsp;
                        {item.label}
                      </span>
                    )
                )}
              </FormControl>
            </TableCell>
            {/* <TableCell align="left">
              <span>{a.last_contacted}</span>
              <br></br>
              <small>{a.time}</small>
            </TableCell> */}

            <TableCell align="left">
              <img
                src={eye}
                style={{ width: "20px", height: "15px" }}
                className="blue-c action-icon cursur me-3"
                onClick={(event) => handleClickView(event, a.customerId, a)}
                alt="view"
              />
              {(roleName === "branch" || roleName === "receptionist") && (
                <img
                  src={edit}
                  style={{ width: "20px", height: "20px" }}
                  className="blue-c action-icon cursur"
                  onClick={(event) => handleClick(event, a.customerId, a)}
                  alt="edit"
                />
              )}
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}
export default React.memo(TableList);
